module.exports = __webpack_public_path__ + "c7a33805ffda0d32bd2a9904c8b02750.png";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/images/color.png
// module id = 374
// module chunks = 1